import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box } from "@mui/material";
import useStyles from "./calendar-weekly-timeline-day-header.style";

interface MyLeaveCalendarWeeklyTimelineDayHeaderProps {
  date: string | Date;
}

export const MyLeaveCalendarWeeklyTimelineDayHeader = ({
  date,
}: MyLeaveCalendarWeeklyTimelineDayHeaderProps) => {
  const { i18n } = useTranslation();
  let label = moment(date).locale(i18n.language).format("dddd");
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <span className={classes.root}>{label}</span>
    </Box>
  );
};

export default MyLeaveCalendarWeeklyTimelineDayHeader;
